
// Configuration for Auth0
export const getAuthConfig = () => ({
  domain: "auth.texassportsproductions.com",
  clientId: "vEJxEJcVJwYVLyhDsL5R9DxCDWLXSnXy",
  authorizationParams: {
    redirect_uri: window.location.origin
  },
  cacheLocation: "localstorage" as const,
});

// Development flag to bypass authentication
export const isDevMode = import.meta.env.DEV;

// Mock auth hook for development when auth is disabled
export const useAuthBypass = () => ({
  isAuthenticated: true,
  isLoading: false,
  user: {
    name: "Dev User",
    email: "dev@example.com",
    picture: "",
  },
  loginWithRedirect: () => {
    window.location.hash = '/dashboard';
  },
  logout: () => {
    window.location.hash = '/';
  },
});
